import { FETCH_UTILISATEURS_FAILURE, FETCH_UTILISATEURS_REQUEST, FETCH_UTILISATEURS_SUCCESS } from "../Types";

const initialState = { utilisateurs: [], loading: false, error: null };

const ListUtilisateursReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_UTILISATEURS_REQUEST:
            return { ...state, loading: true, utilisateurs: [], error: null };

        case FETCH_UTILISATEURS_SUCCESS:
            return { ...state, loading: false, utilisateurs: action.payload };

        case FETCH_UTILISATEURS_FAILURE:
            return { ...state, loading: false, utilisateurs: [], error: action.payload };

        default:
            return state;
    }
};

export default ListUtilisateursReducer;
